import React from 'react';
import { FaBed, FaUser, FaWifi, FaTv } from 'react-icons/fa';

const rooms = [
  {
    name: 'Deluxe Suite',
    description: 'Spacious suite with king-size bed, private balcony, and stunning views.',
    icon: <FaBed className="text-4xl text-gold-500" />,
    capacity: '2 adults',
    amenities: ['Free Wi-Fi', 'Flat-screen TV', 'Air conditioning', 'Mini-bar'],
  },
  {
    name: 'Executive Room',
    description: 'Ideal for business travelers, featuring a work desk and premium amenities.',
    icon: <FaBed className="text-4xl text-gold-500" />,
    capacity: '2 adults',
    amenities: ['Free Wi-Fi', 'Work desk', 'Coffee maker', 'Satellite channels'],
  },
  {
    name: 'Family Suite',
    description: 'Perfect for families, with separate living area and two bedrooms.',
    icon: <FaBed className="text-4xl text-gold-500" />,
    capacity: '4 adults',
    amenities: ['Free Wi-Fi', 'Kitchenette', 'Flat-screen TV', 'Sofa bed'],
  },
];

const Rooms = () => {
  return (
    <section id="rooms" className="py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-gray-800">Our Rooms & Suites</h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Experience comfort and luxury in our beautifully appointed accommodations.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {rooms.map((room, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition">
              <div className="h-48 bg-gray-300 flex items-center justify-center">
                {/* Replace with actual room image */}
                <img src={`/assets/room${index + 1}.jpg`} alt={room.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  {room.icon}
                  <h3 className="text-xl font-semibold ml-3 text-gray-800">{room.name}</h3>
                </div>
                <p className="text-gray-600 mb-4">{room.description}</p>
                <div className="flex items-center text-gray-500 mb-3">
                  <FaUser className="mr-2" />
                  <span>{room.capacity}</span>
                </div>
                <div className="flex flex-wrap gap-2 mb-4">
                  {room.amenities.map((item, i) => (
                    <span key={i} className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded">{item}</span>
                  ))}
                </div>
                <a href="#contact" className="inline-block bg-gold-500 text-white px-4 py-2 rounded hover:bg-gold-600 transition">
                  Book Now
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Rooms;